import anime from 'animejs'

export default () => {
  let resizeTimeout, videoRestartTimeout, position = 0
  const features = document.querySelectorAll('.feature')
  const buttons = document.querySelectorAll('.features button')
  const form = document.querySelector('.contact form')
  const leftArrow = document.querySelector('.features-section .arrow.left')
  const rightArrow = document.querySelector('.features-section .arrow.right')

  features.forEach((feature, index) => {
    const video = feature.querySelector('video')

    feature.querySelector('.feature-summary').addEventListener('click', (e) => {
      playVideo(index)
    }, false)
  })

  buttons.forEach((button, i) => {
    button.addEventListener('click', (e) => {
      animateTo(i)
    }, false)
  })

  leftArrow.addEventListener('click', (e) => {
    const nextPosition = position === 0 ? features.length - 1 : position - 1
    animateTo(nextPosition, false)
  }, false)

  rightArrow.addEventListener('click', (e) => {
    const nextPosition = position === features.length - 1 ? 0 : position + 1
    animateTo(nextPosition, true)
  }, false)

  window.addEventListener("resize", resizeThrottler, false)

  startVideos()

  function startVideos() {
    position = 0
    features.forEach((feature, i) => {
      features[i].removeAttribute('style')
    })
    buttons.forEach(button => {
      button.classList.remove('active')
    })
    if (window.innerWidth < 1099) {
      features[0].setAttribute('style', 'transform: translateX(0)')
    } else {
      features[0].classList.add('active')
    }
    buttons[0].classList.add('active')
    features[0].classList.add('active')
    features[0].querySelector('video').play()
  }

  function playVideo(index) {
    if (window.innerWidth > 1099) {
      focusTo(index)
    } else {
      animateTo(index)
    }
  }

  function focusTo(index) {
    const feature = features[index]
    const video = feature.querySelector('video')
    features.forEach(feature => {
      feature.classList.remove('active')
      feature.querySelector('video').pause()
    })
    video.currentTime = 0
    feature.classList.add('active')
    video.play()
    position = index
  }

  function animateTo(index, direction) {
    if (index === position) return false
    const forwards = typeof direction !== 'undefined' ? direction : index > position
    features.forEach((feature, i) => {
      features[i].querySelector('video').pause()
    })
    buttons.forEach(button => {
      button.classList.remove('active')
    })
    anime({
      targets: features[index],
      translateX: forwards ? ['100%', '0%'] : ['-100%', '0%'],
      duration: 300,
      easing: 'easeInOutQuad',
      begin: () => {
        buttons[index].classList.add('active')
      },
      complete: () => {
        features[index].querySelector('video').play()
      }
    })
    anime({
      targets: features[position],
      translateX: forwards ? ['0%', '-100%'] : ['0%', '100%'],
      duration: 300,
      easing: 'easeInOutQuad'
    })
    position = index
  }

  function resizeThrottler() {
    // Ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null
        startVideos()
       }, 66) // Rate of 15fps
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/phoneDemo.js